// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import TriggerButton from '../toolbar/trigger-button';
import { BreadcrumbsSlot, ToolbarSlot } from './slots';
import testutilStyles from '../../test-classes/styles.css.js';
import toolbarStyles from '../toolbar/styles.css.js';
export function ToolbarContainer({ children, hasAiDrawer }) {
    return (React.createElement("div", { className: clsx(toolbarStyles['toolbar-container'], hasAiDrawer && toolbarStyles['with-ai-drawer']) }, children));
}
export function ToolbarBreadcrumbsSection({ ownBreadcrumbs, discoveredBreadcrumbs, includeTestUtils = false, }) {
    return (React.createElement("div", { className: clsx(toolbarStyles['universal-toolbar-breadcrumbs'], includeTestUtils && testutilStyles.breadcrumbs) },
        React.createElement(BreadcrumbsSlot, { ownBreadcrumbs: ownBreadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs })));
}
export const ToolbarSkeletonStructure = React.forwardRef(({ ariaLabels, expandedDrawerId, hasNavigation, navigationOpen, ownBreadcrumbs, discoveredBreadcrumbs }, ref) => {
    var _a;
    const drawerExpandedMode = !!expandedDrawerId;
    // istanbul ignore next: not interactive during SSR
    const noop = () => { };
    return (React.createElement(ToolbarSlot, { ref: ref },
        React.createElement(ToolbarContainer, null,
            hasNavigation && (React.createElement("nav", { className: toolbarStyles['universal-toolbar-nav'] },
                React.createElement(TriggerButton, { ariaLabel: (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _a !== void 0 ? _a : undefined, ariaExpanded: !drawerExpandedMode && navigationOpen, iconName: "menu", className: testutilStyles['navigation-toggle'], onClick: noop, selected: !drawerExpandedMode && navigationOpen }))),
            React.createElement(ToolbarBreadcrumbsSection, { ownBreadcrumbs: ownBreadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs, includeTestUtils: true }),
            React.createElement("div", { className: toolbarStyles['universal-toolbar-drawers'] }))));
});
//# sourceMappingURL=toolbar-container.js.map